module.exports = __webpack_public_path__ + "static/flyingfish-fc08b3e4808a8f83e5e92de9ed3d073b.png";